import { useLocation } from 'react-router';
import { useAssistCall } from '../lib/assistCall';
import { AssistStage } from './AssistStage';
import { ScreenLink } from './ScreenLink';

/**
 * Where the call is drawn: full size on Assist, hidden -- still joined -- on
 * any other screen, with a bar saying a call is open. Rendered beside the
 * routes, inside the router.
 */
export function AssistCallHost() {
  const shared = useAssistCall();
  const { pathname } = useLocation();
  if (!shared?.call) return null;
  const here = pathname === '/assist';
  const { call, finish } = shared;
  return (
    <>
      <div className="assist-call-host" hidden={!here}>
        <AssistStage
          roomUrl={call.roomUrl}
          token={call.token}
          tenantKey={call.session.tenantKey}
          visible={here}
          onEnded={() => void finish()}
        />
      </div>
      {!here && (
        <div className="assist-call-bar" role="status">
          <span className="assist-call-dot" aria-hidden="true" />
          <span>
            On a call with {call.session.requestedByName || call.session.requestedByEmail || 'an operator'} (
            {call.session.tenantKey}) — still connected.
          </span>
          <span className="wt-spacer" />
          <ScreenLink to="/assist" previewTab="assist" className="btn btn-primary">
            Return to the call
          </ScreenLink>
          <button type="button" className="btn btn-danger" onClick={() => void finish()}>
            End it
          </button>
        </div>
      )}
    </>
  );
}
